





















import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class TextAreaWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public title!: string;
  @Prop(String) public placeholder!: string;
  @Prop(String) public inputName!: string;
  @Prop(String) public initialValue!: string;
  @Prop(String) public staticInputId!: string;
  @Prop(Number) public maxLength!: number;
  @Prop(Number) public cols!: number;
  @Prop(Number) public rows!: number;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public validateOnInput!: boolean;
  @Prop(Boolean) public validateOnBlur!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;

  private inputModel: string = '';
  private inputId: string = '';
  private maxLengthVal: number = 0;

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }

    if (this.validateOnInput) {
      const matcher = {
        name: this.inputId,
        scope: this.formName,
      };
      const field = this.$validator.fields.find(matcher);
      field.update({ events: 'input' });
    }
    if (this.validateOnBlur) {
      const matcher = {
        name: this.inputId,
        scope: this.formName,
      };
      const field = this.$validator.fields.find(matcher);
      field.update({ events: 'blur' });
    }
  }

  public mounted() {
    this.inputModel = this.initialValue;
    if (this.initialValue) {
      this.$emit('input', this.inputModel);
    }
  }

  public updateInputModel($event: any): void {
    if (this.maxLengthVal && $event.target.value.length > this.maxLengthVal) {
      $event.target.value = $event.target.value.slice(0, this.maxLengthVal);
    }
    this.inputModel = $event.target.value;
    this.$emit('input', this.inputModel.length > 0 ? this.inputModel : null);
  }

  public updateInputModelBlur($event: any): void {
    if (this.maxLengthVal && $event.target.value.length > this.maxLengthVal) {
      $event.target.value = $event.target.value.slice(0, this.maxLengthVal);
    }
    this.inputModel = $event.target.value || '';
    this.$emit('blur', this.inputModel.length > 0 ? this.inputModel : null, this.staticInputId );
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    if (this.maxLength) {
      validator.max = this.maxLength;
      this.maxLengthVal = this.maxLength + 1;
    }
    return validator;
  }


  get inputValue(): string {
    // if (!this.inputModel) {
    //   return this.initialValue || '';
    // }
    return this.inputModel || '';
  }

}
